import LazyLoad from "vanilla-lazyload";

export default {
    name : 'LazyLoad',
    init() {
        const lazyContent = new LazyLoad({
        });

        let mouseEvents = document.querySelectorAll(".play-on-mouse-over");

        mouseEvents.forEach(element => {
            element.addEventListener("mouseover", e => {
                element.play();
            })
        });
    }
}